/** A graph node may have several located cells or regions. Keep every match. */
export function selectNodeSources<T extends {node_ids: string[]; original: {id: string}}>(
  sources: T[], nodeId: string, originalId?: string,
): T[] {
  const exact = sources.filter(source => source.node_ids.includes(nodeId));
  return exact.length || !originalId ? exact : sources.filter(source => source.original.id === originalId);
}
